import _isString from "ramda/es/internal/_isString";

const isString = _isString;

export default isString;
